export default function ChartCard({ title, icon, description, children }) {
    return (
        <div className="bg-white rounded-lg sm:rounded-2xl p-3 sm:p-6 shadow-lg border border-gray-100">
            <div className="flex justify-between items-center mb-2 sm:mb-4">
                <h3 className="font-bold text-[14px] sm:text-lg xl:text-xl text-gray-800">
                    {title}
                </h3>
                {/* <EllipsisVertical className="w-4 h-4 sm:w-6 sm:h-6 text-gray-400 cursor-pointer" /> */}
            </div>

            <div className="text-center mb-2 sm:mb-4">
                <div className="mb-1 sm:mb-2">{icon}</div>
                <p className="text-[14px] sm:text-2xl font-semibold text-gray-700">
                    {title}
                </p>
                <p className="text-[10px] sm:text-sm text-gray-500">
                    {description}
                </p>
            </div>

            {children}
        </div>
    );
}

